import { useNavigate, useSearchParams } from "react-router-dom";
import { t } from "../../i18n";

export function OnboardingReviewPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handle = searchParams.get("handle") ?? "";

  const handleContinue = () => {
    navigate(
      `/onboarding/notifications?handle=${encodeURIComponent(handle)}`,
    );
  };

  const handleRate = () => {
    // Open app store (iOS URL - same as RN app)
    window.open(
      "https://apps.apple.com/us/app/stalkie-follow-alerts/id6758714223",
      "_blank",
    );
    handleContinue();
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #fdf2f2 0%, #ffffff 100%)",
        padding: "24px",
      }}
    >
      <div style={{ maxWidth: "360px", width: "100%", textAlign: "center" }}>
        <div style={{ fontSize: "48px", marginBottom: "16px" }}>⭐</div>

        <h1 style={{ fontSize: "1.5rem", fontWeight: 800, color: "#171717", marginBottom: "8px" }}>
          {t("previewWhatDoYouThink")}
        </h1>
        <p style={{ color: "#737373", marginBottom: "32px", fontSize: "0.9375rem", lineHeight: 1.5 }}>
          If you find Stalkie useful, leaving a review helps us a lot!
        </p>

        {/* Stars */}
        <div style={{ display: "flex", justifyContent: "center", gap: "6px", marginBottom: "32px" }}>
          {[...Array(5)].map((_, i) => (
            <span key={i} style={{ fontSize: "32px", color: "#f59e0b" }}>★</span>
          ))}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <button
            onClick={handleRate}
            style={{
              width: "100%",
              padding: "16px",
              background: "var(--pink-primary, #ff6b8a)",
              color: "white",
              border: "none",
              borderRadius: "16px",
              fontWeight: 800,
              fontSize: "1.0625rem",
              cursor: "pointer",
              boxShadow: "0 4px 16px rgba(255, 107, 138, 0.3)",
            }}
          >
            Rate on App Store
          </button>
          <button
            onClick={handleContinue}
            style={{
              width: "100%",
              padding: "16px",
              background: "transparent",
              color: "#737373",
              border: "none",
              borderRadius: "16px",
              fontWeight: 600,
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
